import axios from '../utils/axios';
import qs from 'qs';
// import store from '@/store';
/**
 * 获取群组列表
 * @param params
 * @returns {*}
 */
export async function getNotice(params) {

  return await axios.POST(`/v1/notice/getNotice?` + qs.stringify(params));
}


/**
 * 系统公告
 * @param params
 * @returns {*}
 */
export async function getBulletin(params) {

  return await axios.POST(`/v1/notice/getBulletin?` + qs.stringify(params));
}

/**
 * 把所有消息标记为已读
 * @param params
 * @returns {*}
 */
export async function getReadall(params) {

  return await axios.POST(`/v1/notice/readall?` + qs.stringify(params));
}


/**
 * 获取最新系统公告
 * @param params
 * @returns {*}
 */
export async function getFirstBulletin(params) {

  return await axios.POST(`/v1/notice/getFirstBulletin?` + qs.stringify(params));
}
